module.exports = __webpack_public_path__ + "img/day10.02f0f07e.jpeg";